export const PATHS = {
    DRIVERS: '/drivers',
    AUTH: '/auth',
    REQUESTS: '/orders',
    BOOKINGS: '/bookings',
};
